import { Fade } from '../../components/common'

export default () => (
  <Fade>
    <div className="container">
      <div className="row">
        <div className="col-xs-12">
          <h1>Settings</h1>
        </div>
        <div className="col-xs-12">
          <p>Coming soon...</p>
        </div>
      </div>
    </div>
  </Fade>
)
